export const m0l0Solution = `// Welcome to Starklings: Cairo v1
// This lesson doesn't do anything yet but it still compiles! Every Cairo file
// needs to have a 'main' function.
// Other lessons will require you to write Cairo code to make the lesson file compile.

// do not modify code on this line or above

fn main() {}

// do not modify code on this line or below

#[test]
fn test_compile() {
    assert(1 == 1, 'Surprising');
    main();
}`;
